import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AuthOPEEnum} from "./AuthOPEEnum";

class I {
  userId!: number;
}

class O {
  access_token!: string;
}

export class ImpersonateUserCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(AuthOPEEnum.ImpersonateUser);
    this.i = new I();
    this.o = new O();
  }
}
